var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { MenuItems } from './MenuItems';
import { Button } from '../button/Button';
export const Menu = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleMenuOpen = event => {
        setAnchorEl(event.currentTarget);
        onClick && onClick(event);
        event.stopPropagation();
    };
    const handleMenuClose = event => {
        setAnchorEl(null);
        event.stopPropagation();
    };
    const _a = props.buttonProps, { onClick, className } = _a, buttonProps = __rest(_a, ["onClick", "className"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, Object.assign({ onClick: handleMenuOpen, className: `${props.className} ${className} ${props.showOpenState &&
                anchorEl &&
                'is-open'}` }, buttonProps)),
        anchorEl !== null && (React.createElement(MenuItems, { anchorEl: anchorEl, items: props.items, anchorOrigin: props.anchorOrigin, transformOrigin: props.transformOrigin, isIconAvailable: props.isIconAvailable, handleMenuClose: handleMenuClose }))));
};
Menu.defaultProps = {
    anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
    transformOrigin: { vertical: 'top', horizontal: 'right' },
    className: '',
    isIconAvailable: true
};
//# sourceMappingURL=Menu.js.map